import { extractHostname } from './url-pattern-matching';

export const BUNDLE_RECON_TECH_HOST = 'bundle-recon';

export type ObservedFrontendTech = {
  host: string;
  tech: string;
  version: string | null;
  source: typeof BUNDLE_RECON_TECH_HOST;
};

export const bundleReconTechHost = (pageUrl?: string): string =>
  pageUrl ? extractHostname(pageUrl) : '';

const SCRIPT_TECH_SIGNATURES: ReadonlyArray<{
  tech: string;
  match: RegExp;
}> = [
  { tech: 'Next.js', match: /\/_next\//i },
  { tech: 'Nuxt', match: /\/_nuxt\//i },
  { tech: 'SvelteKit', match: /\/_app\/immutable\/|\.svelte-kit\//i },
  { tech: 'Remix', match: /\/build\/_assets\/|@remix-run/i },
  { tech: 'Gatsby', match: /\/_gatsby\/|\/page-data\//i },
  { tech: 'Vite', match: /@vite\/|\/@fs\/|vite-plugin/i },
  { tech: 'webpack', match: /webpack(?:[-.]|\.runtime)/i },
];

export const inferFrontendTechFromScriptUrls = ({
  urls,
  pageUrl,
}: {
  urls: readonly string[];
  pageUrl?: string;
}): ObservedFrontendTech[] => {
  const host = bundleReconTechHost(pageUrl);
  const seen = new Set<string>();
  const techStack: ObservedFrontendTech[] = [];

  for (const url of urls) {
    for (const signature of SCRIPT_TECH_SIGNATURES) {
      if (seen.has(signature.tech) || !signature.match.test(url)) {
        continue;
      }

      seen.add(signature.tech);
      techStack.push({
        host,
        tech: signature.tech,
        version: null,
        source: BUNDLE_RECON_TECH_HOST,
      });
    }
  }

  return techStack;
};
